export const LocalStorageItems = {
    TENANT_ID: 'tenantId',
    DO_NOT_SHOW_DECLINE_FEEDBACK: 'doNotShowDeclineFeedback',
    SELECTED_LANGUAGE: 'lang',
    TOKEN_EXPIRES_ON: 'tokenExpiresOn'
};

export const SessionStorageItems = {
    CANDIDATE_STATIC_TOKEN: 'candidateToken'
};
